
// add more here as we beef up GWP
export const gwpTypes = {
  threshold: 'threshold',
  product: 'product',
  collection: 'collection'
}

// add more here as we beef up GWP
export const gwpStorageCancelledKeys = {
  threshold: 'gwp_threshold_cancelled',
  product: 'gwp_product_cancelled',
  collection: 'gwp_collection_cancelled'
}
